import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Box, Typography } from "@mui/material";
import SensitivityAnalysisTable from "@Components/SensitivityAnalysisTable";
const SensitivityAnalysisCard = ({ data }) => {
    const { irrAnalysis, npvAnalysis } = data;
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                gap: '10px',
                backgroundColor: 'white',
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                borderRadius: '12px',
                padding: '20px'
            }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: "bold" }, children: "P50 Sensitivity Analysis" }), _jsxs(Box, { sx: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: '10px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                    }, children: [_jsx(SensitivityAnalysisTable, { ...npvAnalysis }), _jsx(SensitivityAnalysisTable, { ...irrAnalysis })] })] }) }));
};
export default SensitivityAnalysisCard;
